import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import FillParent from './FillParent';

const Div = styled(FillParent)`
  background-image: ${({ assets, image }) =>
    image ? `url(${assets[image]})` : 'none'};
  background-size: cover;
  background-position: 50%;
  background-color: ${({ theme }) => theme.palette.background.default};
  text-align: center;
`;

function SimplePage(props) {
  return <Div {...props}>{props.children}</Div>;
}

export default connect(state => ({ assets: state.content.assets }))(SimplePage);
